


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ContextMenuOption from './ContextMenuOption';

@Component({})
export default class ContextMenu extends Vue {
  @Prop({ default: '' }) id!: string;
  @Prop({ default: () => [] }) options!: ContextMenuOption[];
  @Prop({ default: true }) showIcon!: boolean;
  @Prop({ default: false }) showMenu!: boolean;
  @Prop({ default: false }) isCalendar!: boolean;
  @Prop({ default: '0' }) right!: string;

  @Watch('showMenu')
  showMenuChanged(oldValue: boolean, newValue: boolean) {
    setTimeout(() => {
      this.internalShowMenu = this.showMenu;
    }, 50);
  }

  internalShowMenu: boolean = false;

  closeTimer?: number;

  created() {
    this.internalShowMenu = this.showMenu;
  }

  clickOutside() {
    if (this.internalShowMenu) {
      this.closeMenu();
    }
  }

  openMenu() {
    setTimeout(() => {
      this.internalShowMenu = true;
    }, 50);
  }

  closeMenu() {
    this.internalShowMenu = false;

    this.$emit('closed');
  }

  enterOptions() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }

  leaveOptions() {
    this.closeTimer = window.setTimeout(() => {
      this.closeMenu();
    }, 50);
  }

  itemClicked(event: Event) {
    const target = event.currentTarget as Element;
    const action = target.getAttribute('data-action');
    const propsAttr = target.getAttribute('data-props');
    const props = propsAttr ? JSON.parse(propsAttr) : null;

    this.$emit('selected', action, this.id, props);
    this.closeMenu();
  }
}
